import { useState, useEffect } from 'react';
import { Button, Container, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TabComponent from "../../../common/TabComponent";
import { apiService } from "../../../service/api.service";
import Pagination from "react-js-pagination";
import { getStatus, FilterStatus } from "../../../config/config";
import moment from "moment";
import Loader from "../../../common/Loader";

const ViewIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
    </svg>
);

const OrderManagementView = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalItems, settotalItems] = useState(0);
    const [status, setstatus] = useState(null);
    const [search, setsearch] = useState(null);
    const [orders, setorders] = useState();

    const redirect = (type) => {
        navigate(type);
    };

    function handlePageChange(pageNumber) {
        setPage(pageNumber - 1);
        Getorders(pageNumber - 1, limit, status, search);
    }

    useEffect(() => {
        Getorders(page, limit, status, search);
    }, []);

    const Getorders = (page, limit, status, search) => {
        setLoader(true);
        apiService.getOrders(page, limit, status, search).then((res) => {
            console.log("===orders====", res.data.data);
            setorders(res.data.data.list);
            settotalItems(res.data.data.total);
            setLoader(false);
        }).catch((err) => {
            setLoader(false);
            console.log("contact us api error", err.response);
        });
    };

    const tooltip = (
        <Tooltip id="tooltip">
            View Detail
        </Tooltip>
    );

    const onStatusChange = (statusVal) => {
        if (statusVal === "All") {
            statusVal = null;
        }
        setPage(0);
        setstatus(statusVal);
        Getorders(0, limit, statusVal, search);
    };

    const onSearchChange = (searchVal) => {
        if (searchVal && searchVal.trim() !== "") {
            setsearch(searchVal);
            setPage(0);
            Getorders(0, limit, status, searchVal);
        }
    };

    const handleClick = () => {
        setPage(0);
        setsearch(null);
        Getorders(0, limit, status, null);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && search && search.trim() !== "") {
            setPage(0);
            Getorders(0, limit, status, search);
        }
    };

    const getStatusPillClass = (statusStr) => {
        if (!statusStr) return "status-pill status-pill-primary";
        const s = statusStr.toLowerCase();
        if (s.includes("delivered")) return "status-pill status-pill-success";
        if (s.includes("pending") || s.includes("cancel")) return "status-pill status-pill-danger";
        if (s.includes("driver assigned") && !s.includes("not")) return "status-pill status-pill-info";
        if (s.includes("not assigned")) return "status-pill status-pill-warning";
        return "status-pill status-pill-primary";
    };

    const startItem = orders && orders.length > 0 ? page * limit + 1 : 0;
    const endItem = orders && orders.length > 0 ? Math.min((page + 1) * limit, totalItems || orders.length) : 0;

    return (
        <>
            <div className="height-footer dashboard-page order-managemnt-section">
                {loader && <Loader />}
                <Container>
                    <div className="dashboard-shell">
                        <div className="dashboard-sidebar">
                            <TabComponent />
                        </div>
                        <div className="dashboard-main">
                            <div className="tab-pane" id="product-management">
                                <div className="product-management common-under-padding">
                                    {/* Top Control Bar Header */}
                                    <div className="product-header-area status-bar">
                                        <div className="under-heading w-100 d-flex align-items-center justify-content-between flex-wrap gap-3">
                                            <div className="d-flex align-items-center gap-3 flex-wrap flex-grow-1">
                                                <div className="search-box position-relative">
                                                    <img
                                                        className="search-img"
                                                        src={require("../../../assets/images/search.svg").default}
                                                        alt="img"
                                                        onClick={() => onSearchChange(search)}
                                                    />
                                                    <Form.Control
                                                        type="input"
                                                        placeholder="Search by customer name..."
                                                        value={search == null ? "" : search}
                                                        onChange={(e) => setsearch(e.target.value)}
                                                        onKeyDown={handleKeyPress}
                                                    />
                                                    {search != null && search !== "" && (
                                                        <i className="fa fa-times" aria-hidden="true" onClick={handleClick}></i>
                                                    )}
                                                </div>
                                                <div className="select-box-mobile me-3">
                                                    <Form.Select aria-label="Default select status" onChange={(e) => onStatusChange(e.target.value)}>
                                                        <option value={"All"}>All Statuses</option>
                                                        {FilterStatus && FilterStatus.map((data, idx) => (
                                                            <option key={idx} value={data.value}>{data.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Order Table Container Card */}
                                    <div className="table-data product-table-container-card">
                                        <div className="table-responsive">
                                            <table className="table product-view-table">
                                                <thead>
                                                    <tr>
                                                        <th>#Order ID</th>
                                                        <th>Ordered Date</th>
                                                        <th>Customer Name</th>
                                                        <th>Driver Name</th>
                                                        <th>Status</th>
                                                        <th>Order Amount</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orders && orders.map((data, i) => {
                                                        const statusStr = getStatus(data.status);
                                                        const formattedAmount = data.totalAmount ? `$${data.totalAmount.toFixed(2)}` : "$0.00";

                                                        return (
                                                            <tr key={data.orderId || i}>
                                                                <td className="product-id-cell">#{data.orderId}</td>
                                                                <td>
                                                                    <div className="date-time-stack">
                                                                        <span className="date-bold">
                                                                            {moment(data.orderDate).format("MMM DD, YYYY")}
                                                                        </span>
                                                                        <span className="time-muted">
                                                                            {moment(data.orderDate).format("hh:mm A")}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span className="product-title-bold">
                                                                        {data.customer ? data.customer.fullName : "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="product-title-sub">
                                                                        {data.driverName ? data.driverName : "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className={getStatusPillClass(statusStr)}>
                                                                        <span className="dot-indicator"></span>
                                                                        {statusStr || "Pending"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="price-green-bold">{formattedAmount}</span>
                                                                </td>
                                                                <td>
                                                                    <div className="action-btn-row">
                                                                        <OverlayTrigger placement="top" overlay={tooltip}>
                                                                            <Link
                                                                                to={"/order-mangement/order-details/" + data.orderId}
                                                                                className="action-icon-box box-blue"
                                                                            >
                                                                                <ViewIcon />
                                                                            </Link>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>

                                        {orders && orders.length === 0 && (
                                            <div className="nodata centre p-4">
                                                <img src={require("../../../assets/images/no-data-found.png")} alt="img" />
                                                <span>No data Found</span>
                                            </div>
                                        )}

                                        {/* Table Footer */}
                                        {orders && orders.length > 0 && (
                                            <div className="product-table-card-footer">
                                                <div className="showing-info-txt">
                                                    Showing {startItem} to {endItem} of {totalItems || orders.length} orders
                                                </div>
                                                {totalItems > limit && (
                                                    <div className="modern-pagination-tab">
                                                        <Pagination
                                                            activePage={page + 1}
                                                            itemsCountPerPage={limit}
                                                            totalItemsCount={totalItems}
                                                            pageRangeDisplayed={5}
                                                            onChange={(e) => handlePageChange(e)}
                                                            prevPageText="<"
                                                            nextPageText=">"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default OrderManagementView;